module.exports = __webpack_public_path__ + "assets/img/80de-af.svg";